import type {
  RouteLocation,
  RouteLocationNormalized,
  RouteRecordRaw,
} from "vue-router";
import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { canWithRedirection } from "~/core/utils/canWithRedirection";
import {
  PATH_SECTORS,
  PATH_SECTORS_CODE,
  PATH_SECTORS_CODE_DTWINS,
  PATH_SECTORS_CODE_GROUPS,
  PATH_SECTORS_CODE_USERS,
} from "~/modules/sector/constants";
import SectorPage from "~/modules/sector/views/SectorPage.vue";
import SectorsPage from "~/modules/sector/views/SectorsPage.vue";
import { router } from "~/plugins/router";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_SECTORS,
    component: SectorsPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_SECTOR),
      breadcrumb: BREADCRUMBS.SECTOR,
    },
  },
  {
    path: PATH_SECTORS_CODE,
    redirect: (to: RouteLocation) =>
      router.resolve({
        name: PATH_SECTORS_CODE_DTWINS,
        params: { code: to.params.code },
      }),
  },
  {
    path: PATH_SECTORS_CODE_DTWINS,
    component: SectorPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.SECTOR,
    },
  },
  {
    path: PATH_SECTORS_CODE_USERS,
    component: SectorPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_USER),
      breadcrumb: BREADCRUMBS.SECTOR,
    },
  },
  {
    path: PATH_SECTORS_CODE_GROUPS,
    component: SectorPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_USER),
      breadcrumb: BREADCRUMBS.SECTOR,
    },
  },
];

export default routes;
